import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, App } from 'ionic-angular';
import { VisitorProvider } from '../../providers/visitor/visitor';
import { VisitDetailPage } from '../visit-detail/visit-detail';
import { ToastProvider } from '../../providers/toast/toast';
import { PopoverPage } from '../popover/popover';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-visit-list',
  templateUrl: 'visit-list.html',
})
export class VisitListPage {

  visits: any;
  fakevisits: Array<any> = new Array(1);
  selRegistrationLogin: any;

  constructor(private app: App,
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private visitorProvider: VisitorProvider,
    private toast: ToastProvider,
    private popoverCtrl: PopoverController) {
    this.selRegistrationLogin = localStorage.getItem('signup_login')

    if (this.selRegistrationLogin) {
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.")
      this.visits = [{ name: "XYZ Person Name", mobile: '7011xxxxxxx', start_time: '2020-12-11 16:15:25', demo: "This is for Demo Purpose Only." }]

    }
    else {

      this.getResidentVisit();
    }
  }

  getResidentVisit() {
    this.visitorProvider.getVisits().then(val => {
      this.visits = val.data.visits;
      this.visits.forEach((val) => {
        val.visit_data = JSON.parse(val.visit_data)
        if (val.visit_data != null && val.visit_data != undefined) {
          var keys = Object.keys(val.visit_data);
          val.visit_data_keys = keys
        }
      })

    }).catch(val => {
      console.log(val);
    });
  }

  onVisitClick(visit: any) {
    this.app.getRootNav().push(VisitDetailPage, visit);
  }

  deleteVisit(item: any) {
    if (this.selRegistrationLogin) {
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.")
    }
    else {
      this.visitorProvider.deleteVisit(item.id).then(val => {
        if (val.status == "success") {
          this.toast.presentToast('Visit Deleted successfully');
          this.removeByAttr(this.visits, "id", item.id);
        }
      })
    }
  }

  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (arr[i]
        && arr[i].hasOwnProperty(attr)
        && (arguments.length > 2 && arr[i][attr] === value)) {
        this.visits.splice(i, 1);
      }
    }
  }

  doRefresh(refresher) {
    if (this.selRegistrationLogin) {
      setTimeout(() => {
        refresher.complete()
        console.log("yes refreshare timeout complete")
      }, 2000)
    } else {
    this.getResidentVisit();
    }
  }

  


  makeGenericData(data) {
    var type = typeof (data);
    if (type == 'number' && (data == 1 || data == 0)) {
      return data ? 'Yes' : 'no'
    } else {
      return data
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VisitListPage');
  }

}




// WEBPACK FOOTER //
// ./src/pages/visit-list/visit-list.ts